import { Component, OnInit } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import PocketBase from 'pocketbase';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { APP_CONFIG } from '../../shared/constants';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, NavbarComponent, DecimalPipe, NgbPaginationModule, FormsModule, NgSelectModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  assets: any[] = [];
  sortColumn: string = '';
  sortAsc: boolean = true;

  // Pagination
  page = 1;
  pageSize = 10;

  filteredAssets: any[] = [];
  searchText: string = '';

  // Custom tooltip state
  tooltipVisible = false;
  tooltipText = '';
  tooltipX = 0;
  tooltipY = 0;

  // For column header filters
  columnFilters: { [key: string]: string } = {};
  columnFilterOptions: { [key: string]: string[] } = {};

  assetTypeOptions = [
    { value: 'ที่ดินว่างเปล่า', label: 'ที่ดินว่างเปล่า' },
    { value: 'หุ้น', label: 'หุ้น' },
    { value: 'หน่วยลงทุน', label: 'หน่วยลงทุน' },
    { value: 'พันธบัตร', label: 'พันธบัตร' },
    { value: 'ใบสำคัญ', label: 'ใบสำคัญ' },
    { value: 'สลากออมสิน', label: 'สลากออมสิน' },
    { value: 'สลากออมทรัพย์', label: 'สลากออมทรัพย์' },
    { value: 'ห้องชุด', label: 'ห้องชุด' },
    { value: 'ที่ดินพร้อมสิ่งปลูกสร้าง', label: 'ที่ดินพร้อมสิ่งปลูกสร้าง' },
    { value: 'กรรมสิทธิ์ห้องชุด', label: 'กรรมสิทธิ์ห้องชุด' },
    { value: 'สิทธิการเช่า', label: 'สิทธิการเช่า' },
    { value: 'สิทธิการเช่าอาคารพาณิชย์', label: 'สิทธิการเช่าอาคารพาณิชย์' },
    { value: 'สิทธิการเช่าที่ดิน', label: 'สิทธิการเช่าที่ดิน' },
    { value: 'ทรัพย์สินต่างๆ', label: 'ทรัพย์สินต่างๆ' },
    { value: 'สิ่งปลูกสร้าง', label: 'สิ่งปลูกสร้าง' },
    { value: 'สิทธิการเช่าที่ดินฯ', label: 'สิทธิการเช่าที่ดินฯ' },
    { value: 'สิทธิการเช่าสิ่งปลูกสร้าง', label: 'สิทธิการเช่าสิ่งปลูกสร้าง' },
    { value: 'บัตรธนาคาร(เป็นเงินที่ชำระหนี้ได้ตามกฎหมาย)', label: 'บัตรธนาคาร(เป็นเงินที่ชำระหนี้ได้ตามกฎหมาย)' },
    { value: 'สิทธิการเช่าอาคารราชพัสดุ', label: 'สิทธิการเช่าอาคารราชพัสดุ' },
    { value: 'สิทธิการเช่าอาคาร', label: 'สิทธิการเช่าอาคาร' },
    { value: 'สิทธิการไถ่คืน', label: 'สิทธิการไถ่คืน' },
    { value: 'สิทธิการเช่าช่วงที่ดิน', label: 'สิทธิการเช่าช่วงที่ดิน' },
    { value: 'อาวุธปืน', label: 'อาวุธปืน' },
    { value: 'บัตรเงินฝาก', label: 'บัตรเงินฝาก' },
    { value: 'ธนบัตร', label: 'ธนบัตร' },
  ];
  selectedAssetTypes: string[] = ['ห้องชุด'];
  selectedReviewStatuses: string[] = [];

  showFilters = true;
  expandedRow: number | null = null;
  expandedRowHistory: any[] = [];
  expandedRowLoading: boolean = false;

  imageModalOpen = false;
  imageModalSrc: string | null = null;

  reviewStatusOptions = [
    { value: 'ignore', label: 'ข้าม' },
    { value: 'not_interest', label: 'ดูแล้ว ไม่สนใจ' },
    { value: 'interest', label: 'สนใจ' },
    { value: 'target', label: 'เล็ง' },
    { value: 'in_progress', label: 'กำลังดำเนินการ' },
    { value: 'done', label: 'เรียบร้อย' },
  ];
  selectedReviewStatus: string | null = null;

  constructor(private router: Router) {}

  async ngOnInit() {
    // Restore filter preferences from localStorage (SSR-safe)
    if (typeof window !== 'undefined') {
      const savedFilters = localStorage.getItem(APP_CONFIG.LOCAL_STORAGE_KEY.ASSET_TABLE_FILTER);
      if (savedFilters) {
        try {
          const prefs = JSON.parse(savedFilters);
          if (prefs.selectedAssetTypes) this.selectedAssetTypes = prefs.selectedAssetTypes;
          if (prefs.selectedReviewStatuses) this.selectedReviewStatuses = prefs.selectedReviewStatuses;
          if (prefs.searchText) this.searchText = prefs.searchText;
          if (prefs.columnFilters) this.columnFilters = prefs.columnFilters;
        } catch {}
      }
    }
    // SSR-safe: do not use window, always create a new PocketBase instance
    const pb = new PocketBase(environment.pocketBaseUrl);
    if (!pb.authStore.isValid) {
      if (typeof window !== 'undefined') {
        await Swal.fire({
          icon: 'error',
          title: 'Session หมดอายุ',
          text: 'กรุณาเข้าสู่ระบบใหม่',
        });
        this.router.navigate(['/login']);
      }
      return;
    }
    try {
      const result = await pb.collection(environment.pocketBaseColInfoAssets).getFullList({
        sort: '-created',
        $autoCancel: false
      });
      this.assets = result.map((item: any) => ({
        id: item.id,
        sale_order: item.sale_order,
        case_no: item.case_no,
        asset_type: item.asset_type,
        size_rai: item.size_rai,
        size_ngan: item.size_ngan,
        size_trwa: item.size_trwa,
        estimate_price: item.estimate_price,
        subdistrict: item.subdistrict,
        district: item.district,
        province: item.province,
        read_status: item.read_status,
        // Map all additional fields from PocketBase
        collectionId: item.collectionId,
        collectionName: item.collectionName,
        created: item.created,
        updated: item.updated,
        detail_assets_map: item.detail_assets_map,
        detail_assets_no: item.detail_assets_no,
        detail_assets_photo: item.detail_assets_photo,
        detail_deed_no: item.detail_deed_no,
        detail_page_url: item.detail_page_url,
        detail_round_1_1: item.detail_round_1_1,
        detail_round_1_2: item.detail_round_1_2,
        detail_round_2_1: item.detail_round_2_1,
        detail_round_2_2: item.detail_round_2_2,
        detail_round_3_1: item.detail_round_3_1,
        detail_round_3_2: item.detail_round_3_2,
        detail_round_4_1: item.detail_round_4_1,
        detail_round_4_2: item.detail_round_4_2,
        detail_round_5_1: item.detail_round_5_1,
        detail_round_5_2: item.detail_round_5_2,
        detail_round_6_1: item.detail_round_6_1,
        detail_round_6_2: item.detail_round_6_2,
        is_reviewed: item.is_reviewed,
        review_status: item.review_status
      }));
    } catch (err) {
      if (typeof window !== 'undefined') {
        await Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'เกิดข้อผิดพลาดในการโหลดข้อมูลทรัพย์สิน',
        });
      }
      this.assets = [];
    }
    finally {
      console.log('Assets loaded:', this.assets.length);
    }
    this.onSearchChange();
    this.updateColumnFilterOptions();
  }

  updateColumnFilterOptions() {
    const columns = [
      'read_status', // <-- add status column
      'sale_order', 'case_no', 'asset_type', 'size_rai', 'size_ngan', 'size_trwa',
      'estimate_price', 'province'
    ];
    const assets = this.filteredAssets.length ? this.filteredAssets : this.assets;
    console.log('Assets loaded (2):', assets.length);
    // Handle regular columns
    columns.forEach(col => {
      const values = assets.map(a => a[col]).filter(v => v !== undefined && v !== null);
      this.columnFilterOptions[col] = Array.from(new Set(values.map(v => v.toString()))).sort();
    });
    
    // Handle combined subdistrict/district column
    const combinedValues = assets.map(a => {
      const subdistrict = a.subdistrict || '';
      const district = a.district || '';
      return `${subdistrict} / ${district}`;
    }).filter(v => v !== ' / '); // Filter out empty combinations
    
    this.columnFilterOptions['subdistrict'] = Array.from(new Set(combinedValues)).sort();
  }

  saveFilterPreferences() {
    if (typeof window !== 'undefined') {
      const prefs = {
        selectedAssetTypes: this.selectedAssetTypes,
        selectedReviewStatuses: this.selectedReviewStatuses,
        searchText: this.searchText,
        columnFilters: this.columnFilters
      };
      localStorage.setItem(APP_CONFIG.LOCAL_STORAGE_KEY.ASSET_TABLE_FILTER, JSON.stringify(prefs));
    }
  }
  onAssetTypeChange() {
    this.onSearchChange();
    this.saveFilterPreferences();
  }

  onReviewStatusChange() {
    this.onSearchChange();
    this.saveFilterPreferences();
  }

  onColumnFilterChange(column: string, value: string) {
    this.columnFilters[column] = value;
    this.onSearchChange();
    this.saveFilterPreferences();
  }

  onSearchChange() {
    const search = this.searchText.trim().toLowerCase();
    let filtered = this.assets;

    if (this.selectedAssetTypes.length > 0) {
      filtered = filtered.filter(asset =>
        this.selectedAssetTypes.includes(asset.asset_type)
      );
    }
    if (this.selectedReviewStatuses.length > 0) {
      filtered = filtered.filter(asset =>
        this.selectedReviewStatuses.includes(asset.review_status)
      );
    }
    // Apply column header filters
    Object.entries(this.columnFilters).forEach(([col, val]) => {
      if (val && val.trim() !== '') {
        if (col === 'subdistrict') {
          // Handle combined subdistrict/district filter
          filtered = filtered.filter(asset => {
            const combinedValue = `${asset.subdistrict || ''} / ${asset.district || ''}`;
            return combinedValue === val;
          });
        } else {
          // Handle regular column filters
          filtered = filtered.filter(asset =>
            asset[col] !== undefined && asset[col] !== null && asset[col].toString() === val
          );
        }
      }
    });
    if (search) {
      filtered = filtered.filter(asset =>
        Object.values(asset).some(val =>
          val !== null && val !== undefined && val.toString().toLowerCase().includes(search)
        )
      );
    }
    this.filteredAssets = filtered;
    this.page = 1;
    this.updateColumnFilterOptions();
    
    // Reset expanded row but only restore after user-initiated filter changes, not initial load
    this.expandedRow = null;
    this.expandedRowHistory = [];
  }

  onSearchTextChange() {
    this.onSearchChange();
    this.saveFilterPreferences();
  }

  highlight(text: any): string {
    if (!text) return '';
    const search = this.searchText.trim();
    if (!search) return text.toString();
    const re = new RegExp(`(${search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    return text.toString().replace(re, '<span class="bg-warning text-dark">$1</span>');
  }

  sortTable(column: string) {
    if (this.sortColumn === column) {
      this.sortAsc = !this.sortAsc;
    } else {
      this.sortColumn = column;
      this.sortAsc = true;
    }
  }

  sortedAssets() {
    const arr = this.filteredAssets;
    if (!this.sortColumn) return arr;
    return [...arr].sort((a, b) => {
      const aValue = a[this.sortColumn];
      const bValue = b[this.sortColumn];
      if (aValue == null) return 1;
      if (bValue == null) return -1;
      if (typeof aValue === 'number' && typeof bValue === 'number') {
        return this.sortAsc ? aValue - bValue : bValue - aValue;
      }
      return this.sortAsc
        ? String(aValue).localeCompare(String(bValue))
        : String(bValue).localeCompare(String(aValue));
    });
  }

  pagedAssets() {
    const sorted = this.sortedAssets();
    const start = (this.page - 1) * this.pageSize;
    return sorted.slice(start, start + this.pageSize);
  }

  get filteredAssetsCount() {
    return this.sortedAssets().length;
  }

  onPageChange(newPage: number) {
    this.page = newPage;
    // Collapse all expanded rows when page changes
    this.expandedRow = null;
    this.expandedRowHistory = [];
    this.selectedReviewStatus = null; // Reset dropdown when page changes
  }

  async toggleRow(index: number) {
    if (this.expandedRow === index) {
      this.expandedRow = null;
      this.expandedRowHistory = [];
      this.selectedReviewStatus = null; // Reset dropdown when collapsing
      return;
    }
    this.expandedRow = index;
    this.expandedRowHistory = [];
    this.expandedRowLoading = true;
    
    // Get the asset's PocketBase id (need to find the id from filteredAssets)
    const asset = this.pagedAssets()[index];
    if (!asset || !asset.id) {
      this.expandedRowLoading = false;
      return;
    }
    
    // Set the dropdown to show the current review_status of the expanded record
    this.selectedReviewStatus = asset.review_status || null;
    
    // Save expanded row preference
    
    try {
      const pb = new PocketBase(environment.pocketBaseUrl);
      const result = await pb.collection(environment.pocketBaseColInfoAssetsHistory).getFullList({
        filter: `assets_id = "${asset.id}"`,
        sort: '-created',
        $autoCancel: false
      });
      // Sort history rows from newest to oldest (descending by created)
      this.expandedRowHistory = result.sort((a, b) => {
        const aTime = new Date(a['created']).getTime();
        const bTime = new Date(b['created']).getTime();
        return bTime - aTime;
      });
    } catch (err) {
      this.expandedRowHistory = [];
    }
    this.expandedRowLoading = false;
  }

  // Returns an array of diff maps for each history row, compared to the next newer row (or current row for the last)
  getExpandedRowDiffs(i: number) {
    const history = this.expandedRowHistory;
    const current = this.pagedAssets()[i];
    const allRows = [...history, current]; // oldest to newest (current is last)
    const fields = [
      'case_no', 'detail_deed_no',
      'detail_round_1_1', 'detail_round_1_2',
      'detail_round_2_1', 'detail_round_2_2',
      'detail_round_3_1', 'detail_round_3_2',
      'detail_round_4_1', 'detail_round_4_2',
      'detail_round_5_1', 'detail_round_5_2',
      'detail_round_6_1', 'detail_round_6_2',
      'detail_assets_map', 'detail_assets_photo'
    ];
    // For each history row, compare to the next newer row
    return history.map((row, idx) => {
      const nextRow = allRows[idx + 1];
      const diff: { [key: string]: boolean } = {};
      fields.forEach(f => {
        diff[f] = row[f] !== nextRow[f];
      });
      return diff;
    });
  }

  openImageModal(src: string) {
    this.imageModalSrc = src;
    this.imageModalOpen = true;
  }
  closeImageModal() {
    this.imageModalOpen = false;
    this.imageModalSrc = null;
  }

  async onSubmitReviewStatus() {
    if (this.expandedRow === null) {
      if (typeof window !== 'undefined') {
        await Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่พบข้อมูลทรัพย์สินที่ต้องการอัปเดต',
        });
      }
      return;
    }

    const asset = this.pagedAssets()[this.expandedRow];
    if (!asset || !asset.id) {
      if (typeof window !== 'undefined') {
        await Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่พบข้อมูลทรัพย์สินที่ต้องการอัปเดต',
        });
      }
      return;
    }

    try {
      const pb = new PocketBase(environment.pocketBaseUrl);
      
      // Update the asset record with review status (null if no selection) and mark as reviewed
      await pb.collection(environment.pocketBaseColInfoAssets).update(asset.id, {
        review_status: this.selectedReviewStatus || null,
        is_reviewed: true
      });

      // Update the local asset data to reflect the changes
      const assetIndex = this.assets.findIndex(a => a.id === asset.id);
      if (assetIndex !== -1) {
        this.assets[assetIndex].review_status = this.selectedReviewStatus || null;
        this.assets[assetIndex].is_reviewed = true;
      }

      // Show success message
      if (typeof window !== 'undefined') {
        await Swal.fire({
          icon: 'success',
          title: 'บันทึกสำเร็จ',
          text: 'อัปเดตสถานะรีวิวเรียบร้อยแล้ว',
          timer: 2000,
          showConfirmButton: false
        });
      }

      // Keep the dropdown value - don't reset it
      
    } catch (err) {
      console.error('Error updating review status:', err);
      if (typeof window !== 'undefined') {
        await Swal.fire({
          icon: 'error',
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถอัปเดตสถานะรีวิวได้ กรุณาลองใหม่อีกครั้ง',
        });
      }
    }
  }

  showTooltip(event: MouseEvent, text: string): void {
    this.tooltipVisible = true;
    this.tooltipText = text;
    
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    
    // Center the tooltip horizontally on the element
    this.tooltipX = rect.left + (rect.width / 2);
    this.tooltipY = rect.top - 35; // Position above the element
  }

  hideTooltip(): void {
    this.tooltipVisible = false;
    this.tooltipText = '';
  }

  getReviewStatusLabel(status: string): string {
    const statusMap: { [key: string]: string } = {
      'ignore': 'ข้าม',
      'not_interest': 'ดูแล้ว ไม่สนใจ',
      'interest': 'สนใจ',
      'target': 'เล็ง',
      'in_progress': 'กำลังดำเนินการ',
      'done': 'เรียบร้อย'
    };
    return statusMap[status] || status;
  }
}
